import gql from 'graphql-tag';

export const QUERY_COUNTRY = gql`
  query country($pageSize: Int, $pageNumber: Int, $countrySlugs: [String], $name: String) {
    countries(
      pageNumber: $pageNumber
      pageSize: $pageSize
      countrySlugs: $countrySlugs
      name: $name
    ) {
      edges {
        node {
          name
          id
          countryCode
          slug
        }
      }
    }
  }
`;
